<template>
  <QuizeBox
    :postQuestionGet="postQuestionGet"
    :postQuestionSubmit="postQuestionSubmit" />
</template>
<script>
import { postQuestionGet, postQuestionSubmit } from '@/api/user'
import QuizeBox from '@/components/QuizeBox.vue'

export default {
  name: 'UserQuizDetail',
  components: { QuizeBox },
  data() {
    return {
      postQuestionGet,
      postQuestionSubmit
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/quizdetail.vue